import { Fragment } from 'react'
import { Grid } from '@material-ui/core'
import { HtmlTooltip } from '../../html_tooltip'

export const MultiColorProgressBar = (props) => {
  const readings = props.readings

  let bars =
    readings &&
    readings.length &&
    readings.map(function (item, i) {
      if (item.value > 0) {
        return (
          <HtmlTooltip
            title={
              <Fragment>
                <Grid column spacing={2}>
                  <Grid item>{item.title}</Grid>
                  <Grid item>{item.value} tantiemes</Grid>
                  <Grid item>{item.count} coproprietaires</Grid>
                </Grid>
              </Fragment>
            }
            key={i}
          >
            <div
              className="bar"
              style={{ backgroundColor: item.color, width: item.percent + '%' }}
            >
              {item.percent}%
            </div>
          </HtmlTooltip>
        )
      }
    }, this)

  return (
    <div className="multicolor-bar">
      <div className="bars">{bars == '' ? '' : bars}</div>
    </div>
  )
}
export default MultiColorProgressBar
